import { useCallback } from 'react';

import FertProductSelectField from 'fields/FertProductSelectField';
import { useField } from 'formik';

import type { IProductName } from './types';

export default function ProductName({
  disabled,
  location,
  selectedSubGroupDescription,
}: IProductName) {
  const [, { value: packagedItemReference }, { setValue: setPackagedItemReference }] =
    useField('packagedItemReference');
  const [, { value: paymentTermCode }, { setValue: setPaymentTermCode }] = useField(
    'paymentTerms.paymentTermsCode',
  );

  const handleChange = useCallback(async () => {
    if (packagedItemReference) {
      await setPackagedItemReference(''); // Reset bag size when product is changed
    }
    if (paymentTermCode) {
      await setPaymentTermCode(''); // Reset payment term code when product is changed
    }
  }, [packagedItemReference, setPackagedItemReference, paymentTermCode, setPaymentTermCode]);

  return (
    <FertProductSelectField
      textFieldProps={{ required: true }}
      name="itemGroupRef"
      disabled={disabled}
      location={location}
      onChange={handleChange}
      subGroup={selectedSubGroupDescription}
    />
  );
}
